<template>
    <kubernetes-common-panel
            v-model="value"
            :img="img"
            :readOnly="readOnly"
            @openDesDoc="desDocOpen"
            @close="closePanel"
    >
        <template slot="headline">
            <v-tabs
                    v-model="activeTab"
                    v-if="value.status">
                <v-tab
                        v-for="(tab, idx) in tabItems"
                        :key="idx">
                    <v-list-item-title>{{ tab }}</v-list-item-title>
                </v-tab>
            </v-tabs>
            <v-list-item-title 
                    v-else
                    class="headline">
                {{ value._type }}
            </v-list-item-title>
        </template>

        <template slot="descriptionText">
            <span>{{ descriptionText }}</span>
        </template>

        <template slot="edit-layout">
            <v-layout v-if="value.status && activeTab == 0" wrap>
                    <v-flex>
                        <v-card flat>
                            <v-card-text>
                                <tree-view
                                        :data="status"
                                        :options="{
                                                rootObjectKey: 'status',
                                                readOnly: readOnly
                                            }"
                                ></tree-view>
                            </v-card-text>
                        </v-card>
                    </v-flex>
                </v-layout>
                <v-layout v-else wrap>
                    <v-flex shrink style="width: 180px;">
                        <v-card flat>
                            <v-card-text>
                                <v-text-field
                                        label="Name"
                                        v-model="value.object.metadata.name"
                                        autofocus
                                        :disabled="readOnly"
                                ></v-text-field>
                                <kube-number-field
                                        :desDoc="'#replicas'"
                                        @openDesDoc="desDocOpen"
                                        :label="'Replicas'"
                                        v-model="value.object.spec.replicas"
                                        :readOnly="readOnly"
                                ></kube-number-field>
                                <kube-template-field
                                        v-model="value.object"
                                        :readOnly="readOnly"
                                ></kube-template-field>
                                <kube-attr-field 
                                        v-model="value" 
                                        :readOnly="readOnly"
                                ></kube-attr-field>
                            </v-card-text>
                        </v-card>
                    </v-flex>
                    <v-flex>
                        <kube-yaml-editor
                                v-model="value.object"
                                :readOnly="readOnly"
                        ></kube-yaml-editor>
                    </v-flex>
                </v-layout>
        </template>
    </kubernetes-common-panel>

</template>


<script>
    import KubernetesPanel from "../KubernetesPanel";

    export default {
        mixins: [KubernetesPanel],
        name: 'property-panel',
        computed: {
            descriptionText() {
                return 'ReplicaSet'
            },
            status() {
                return JSON.parse(JSON.stringify(this.value.status))
            }
        },
        data: function () {
            return {
                activeTab: 0,
                tabItems: ["status", "property"],
            }
        },
        watch: {
            status: {
                deep: true,
                handler: function () {
                }
            }
        },
        methods: {
            desDocOpen(property) {
                var url = 'https://kubernetes.io/docs/concepts/workloads/controllers/replicaset/'
                if (property) {
                    url += property
                }
                window.open(url)
            },
        }
    }
</script>

